module.exports = __webpack_public_path__ + "img/main.90a5e029.png";